import { format } from "date-fns";
import { nl } from 'date-fns/locale';

export const getCurrentDateTimeAsString = () => {
  return ""+format(new Date(), 'eeee dd-MM-yyyy HH:mm', {locale: nl}) + " uur";
};